import { useQueryApi } from 'utils/api'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { UseQueryOptions } from 'react-query'
import type {
  ParamsApiGetPerencanaanList,
  ResponseApiGetPerencanaanList,
} from 'types/kinerja-gpk'

const BASE_PATH = '/guru/skp'

// -------------------------------------
// Get Perencanaan list
// -------------------------------------
export const API_GET_PERENCANAAN_LIST_QUERY_KEY =
  'API_GET_PERENCANAAN_LIST_QUERY_KEY'

export function useApiGetPerencanaanList({
  params,
  options,
}: {
  params: ParamsApiGetPerencanaanList
  options?: UseQueryOptions<ResponseApiGetPerencanaanList>
}) {
  const { periodYear, periodNo } = usePeriodContext()
  const {
    skpYear = periodYear,
    skpPeriod = periodNo,
    states,
    isMetaOnly = false,
  } = params

  const queryKey = [
    API_GET_PERENCANAAN_LIST_QUERY_KEY,
    skpYear,
    skpPeriod,
    states,
  ]

  return useQueryApi<ResponseApiGetPerencanaanList>(
    `${BASE_PATH}/v1/gpk/perencanaan-skp/all`,
    {
      queryConfig: {
        ...options,
      },
      axiosConfig: {
        params: {
          skpYear,
          skpPeriod,
          // If `isMetaOnly` is true, send empty array to only get the metadata.
          // Otherwise, send the states.
          states: isMetaOnly ? [] : states ?? [],
        },
      },
      queryKey,
    }
  )
}
